import React, { useEffect, useMemo, useRef, useState } from "react";
import { Button, Container } from "react-bootstrap";
import { MdDeleteOutline } from "react-icons/md";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../API/config";
import moment from "moment";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { message, Radio, RadioChangeEvent, Space } from "antd";
import ShippingAddress from "./ShippingAddress";
import { eventManager } from "../EventEmitter";

interface Variant {
  variantName: string;
  storage: string;
  colorCode: string;
  colorName: string;
  ramSize: string;
  price: number;
  dealPrice: number;
  _id: string;
}

interface Address {
  addressType: string;
  gstNumber: string;
  businessName: string;
  alternateNumber: string;
  buildingAndBlockNumber: string;
  email: string;
  firstName: string;
  houseNumberAndFloor: string;
  landmark: string;
  lastName: string;
  locality: string;
  phoneNumber: string;
  pincode: string;
}

interface CartItem {
  variantId: any;
  variant: Variant;
  product: string;
  price: number;
  DeliveryType: string;
  productName: string;
  _id: string;
  categories: string;
}

interface WishlistItem {
  variant: Variant;
  product: string;
  price: number;
  _id: string;
}

interface User {
  _id: string;
  email: string;
  role: string;
  cart: CartItem[];
  wishlist: WishlistItem[];
  __v: number;
  termscondition: boolean;
  passwordChangedAt: string;
  firstName: string;
  lastName: string;
  position: string;
  shippingAddress: {
    addressType: string;
    gstNumber: string;
    businessName: string;
    alternateNumber: string;
    buildingAndBlockNumber: string;
    email: string;
    firstName: string;
    houseNumberAndFloor: string;
    landmark: string;
    lastName: string;
    locality: string;
    phoneNumber: string;
    pincode: string;
  };
  ExchangeType: string;
}

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

const Cart = () => {
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);
  const [isContinue, setIsContinue] = useState(true);
  const [quantities, setQuantities] = useState<number[]>([]);
  const [isCouponApplied, setIsCouponApplied] = useState(false);
  const [ogPincode, setOGPincode] = useState<any[]>([]);
  const [data, setData] = useState<User | null>(null);
  const [isPayment, setIsPayment] = useState(false);
  const [deliveryType, setDeliveryType] = useState("Standard");
  const [messageApi, contextHolder] = message.useMessage();
  const [addressData, setAddressData] = useState<Address>({
    addressType: "",
    gstNumber: "",
    businessName: "",
    alternateNumber: "",
    buildingAndBlockNumber: "",
    email: "",
    firstName: "",
    houseNumberAndFloor: "",
    landmark: "",
    lastName: "",
    locality: "",
    phoneNumber: "",
    pincode: "",
  });
  const success = (content: any) => {
    messageApi.open({
      type: "success",
      content: content,
      className: "custom-class",
    });
  };

  const errormessage = (content: any) => {
    messageApi.open({
      type: "error",
      content: content,
      className: "custom-class",
    });
  };

  const [coupon, setCoupon] = useState({
    couponcode: "",
    message: "",
  });
  const [isButtonEnabled, setIsButtonEnabled] = useState(false);
  const [value, setValue] = useState("Home");
  const [showAddressForm, setShowAddressForm] = useState(false);
  const [isLoc, setIsloc] = useState(false);
  const [isAddressSaved, setIsAddressSaved] = useState(false);
  const [isAddress, setIsAddress] = useState({
    gstNumber: "",
    businessName: "",
    addressType: "Home",
    alternateNumber: "",
    buildingAndBlockNumber: "",
    email: "",
    firstName: "",
    houseNumberAndFloor: "",
    landmark: "",
    lastName: "",
    locality: "",
    phoneNumber: "",
    pincode: "",
  });

  const handleClose = () => {
    navigate("/orders");
    setOpen(false);
    setIsPayment(false);
  };

  const getUser = async () => {
    const token = sessionStorage.getItem("token"); 
             if(!token){
               message.error("Login required!") 
               return
             }

    try {
      const res = await axios.get(`${API_URL}/api/user/getMe`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setData(res.data.user);
      setQuantities(res.data.user.cart.map(() => 1));
    } catch (error: any) {
      console.log(error);
      errormessage(
        error.response?.data?.message || "Failed to fetch products."
      );
    }
  };

  const handleremoveCart = async (data: any) => {
    const token = sessionStorage.getItem("token"); 
             if(!token){
               message.error("Login required!") 
               return
             }
    try {
      const cartData = {
        cartItemId: data._id,
      };

      await axios.delete(`${API_URL}/api/user/cart/remove`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: cartData,
      });
      success("Removed from Cart");
      eventManager.emit("cartUpdated");
      await getUser();
    } catch (error: any) {
      console.log(error);
      errormessage(
        error.response?.data?.message || "Failed to fetch products."
      );
    }
  };

  const handleIncrement = (index: number) => {
    setQuantities((prev) => {
      const updated = [...prev];
      updated[index] += 1;
      return updated;
    });
  };

  const enableCartButton = () => {
    setIsButtonEnabled(true);
  };
  const handleDecrement = (index: number) => {
    setQuantities((prev) => {
      const updated = [...prev];
      if (updated[index] > 1) updated[index] -= 1;
      return updated;
    });
  };

  const [totalprice, setTotalPrice] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [couponCode, setCouponCode] = useState("");

  const shippingCharges = useMemo(() => {
    if (deliveryType === "Express") {
      return "100.00";
    }

    return (totalprice ?? 0) < 1000
      ? (100).toFixed(2) + "(Above 1000 free)"
      : "Free";
  }, [totalprice]);

  const calculateOrderTotal = () => {
    const baseTotal = data?.cart.reduce((total, item, index) => {
      const itemPrice = item.variant.dealPrice;
      const itemTotal = itemPrice * quantities[index];
      return total + itemTotal;
    }, 0);

    const deliveryFee = deliveryType === "Standard" ? 0 : 100;

    const total = baseTotal && baseTotal + deliveryFee;
    return total ? total.toFixed(2) : "0.00";
  };

  useEffect(() => {
    const total = calculateOrderTotal();
    setTotalPrice(Number(total));
  }, [data?.cart, quantities, deliveryType]);

  const [discountPercent, setDiscountPercent] = useState(0);
  const checkCoupon = async () => {
     const token = sessionStorage.getItem("token"); 
              if(!token){
                message.error("Login required!") 
                return
              }
    try {
      if (coupon.couponcode) {
        const res = await axios.post(
          `${API_URL}/api/banner/coupon`,
          { couponCode: coupon.couponcode },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        // Extract the dynamic key and then access the data
        const resultData = res.data.result;
        const dynamicKey = Object.keys(resultData)[0];
        const bannerData = resultData[dynamicKey];

        if (bannerData && bannerData.length > 0) {
          const discountPercent = bannerData[0].discount;
          setCouponCode(bannerData[0].couponCode);
          const discountAmount =
            totalprice - (totalprice * discountPercent) / 100;
          setDiscountPercent(discountPercent);
          setDiscount(discountAmount);
          setTotalPrice(discountAmount);
          setIsCouponApplied(true);
          setCoupon({ ...coupon, message: "Coupon applied successfully!" });
        } else {
          setDiscount(0);
          setIsCouponApplied(false);
          setCoupon({ ...coupon, message: "Coupon expired or invalid!" });
        }
      } else {
        setCoupon({ ...coupon, message: "Enter coupon code!" });
      }
    } catch (error: any) {
      errormessage(
        error.response?.data?.message || "Failed to fetch products."
      );
      setCoupon({
        ...coupon,
        message: error.response?.data?.message || "An error occurred",
      });
    }
  };

  const onChange = (e: RadioChangeEvent) => {
    setValue(e.target.value);
    setIsAddress({ ...isAddress, addressType: e.target.value });
  };
  const onChangeType = (e: RadioChangeEvent) => {
    setDeliveryType(e.target.value);
  };

  const [pincodeRes, setPincodeRes] = useState<any[]>([]);

  const handlepostAddress = async () => {
    const token = sessionStorage.getItem("token");
    await handlegetPincode();
  };

  const handlegetPincode = async () => {
    const token = sessionStorage.getItem("token"); 
             if(!token){
               message.error("Login required!") 
               return
             }
    try {
      const res = await axios.get(`${API_URL}/api/delivery-info`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const filterPin = res.data.filter(
        (val: any) => val.pincode === isAddress.pincode
      );
      setPincodeRes(filterPin);
      setOGPincode(res.data);
    } catch (error: any) {
      errormessage(
        error.response?.data?.message || "Failed to fetch products."
      );
    }
  };

  const renderCount = useRef(0);

  useEffect(() => {
    renderCount.current += 1;

    // Skip the first two renders
    if (renderCount.current <= 2) {
      return;
    }

    if (pincodeRes.length === 0) {
      message.error("Unable to deliver to this pincode");
      return;
    }

    const dd = localStorage.getItem("address");
    let updatedShippingAddress;

    if (dd === "SameAddress") {
      updatedShippingAddress = { shippingAddress: isAddress };
    } else {
      updatedShippingAddress = { gstAddress: isAddress };
    }

     const token = sessionStorage.getItem("token"); 
              if(!token){
                message.error("Login required!") 
                return
              }
    axios
      .patch(`${API_URL}/api/user/shipping-address`, updatedShippingAddress, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(() => {
        success("Address Updated");
        setIsloc(false);
        setIsPayment(true);
      })
      .catch((error: any) => {
        console.log(error.response?.data?.message || "An error occurred");
        errormessage(error.response?.data?.message || "An error occurred");
      });
  }, [pincodeRes]);

  // const handlePincodeFilter = () => {
  //   const estimateDate = ogPincode.filter(
  //     (val) => val.pincode === isAddress.pincode
  //   );
  //   setPincodeRes(estimateDate);
  // };

  const handleclearCart = async () => {
    const token = sessionStorage.getItem("token"); 
             if(!token){
               message.error("Login required!") 
               return
             }

    try {
      if (data?.cart && data.cart.length > 0) {
        await Promise.all(
          data.cart.map((val) =>
            axios.delete(`${API_URL}/api/user/cart/remove`, {
              headers: {
                Authorization: `Bearer ${token}`,
              },
              data: { cartItemId: val._id },
            })
          )
        );
      }
    } catch (error: any) {
      errormessage(
        error.response?.data?.message || "Failed to fetch products."
      );
    }
  };

  const handlePhonepe = async () => {
    try {
      const token = sessionStorage.getItem("token"); 
               if(!token){
                 message.error("Login required!") 
                 return
               }
 

      const amt = calculateOrderTotal();

      const res = await axios.post(
        `${API_URL}/pay`,
        { amount: Number(amt) },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const calculateCartTotal = () => {
        const baseTotal = data?.cart.reduce((total, item, index) => {
          const itemPrice = item.variant.dealPrice;
          const itemTotal = itemPrice * quantities[index];
          return total + itemTotal;
        }, 0);

        const deliveryFee = deliveryType === "Standard" ? 0 : 100;

        const total = baseTotal && baseTotal + deliveryFee;
        return total ? total.toFixed(2) : "0";
      };

      const totalAmount = parseFloat(calculateCartTotal());
      const discountAmount = (totalAmount * discountPercent) / 100;
      const finalAmount =
        totalAmount - discountAmount >= 1000
          ? (totalAmount - discountAmount).toFixed(2)
          : (totalAmount - discountAmount + 100).toFixed(2);

      const dta = localStorage.getItem("address");
      let updatedShippingAddress;

      if (dta === "SameAddress") {
        updatedShippingAddress = { shippingAddress: isAddress };
      } else {
        updatedShippingAddress = { gstAddress: isAddress };
      }

      const orderData = {
        user: data?._id,
        products: data?.cart.map((item, index) => ({
          productId: item.product,
          productPrice: item.variant.dealPrice
            ? item.variant.dealPrice
            : item.variant.price,
          quantity: quantities[index],
          ram: item.variant.ramSize,
          storage: item.variant.storage,
          colorName: item.variant.colorName,
          productName: item.productName,
          variantId: item.variantId,
          categories: item.categories,
        })),
        ...(dta === "SameAddress"
          ? { shippingAddress: isAddress }
          : { gstAddress: isAddress }),
        ...(dta === "SameAddress" ? { isGst: false } : { isGst: true }),
        totalAmount,
        finalAmount,
        orderDate: new Date(),
        paymentMethod: "upi",
        totalDiscountedAmount: discountAmount,
        paymentStatus: "pending",
        paymentAmount: finalAmount,
        status: "ordered",
        exchange: data?.ExchangeType === "without exchange" ? false : true,
        deliveryType: deliveryType,

        deliveryDate:
          deliveryType === "Standard"
            ? moment().add(pincodeRes[0]?.standardDeliveryDate, "days")
            : moment().add(pincodeRes[0]?.expressDeliveryDate, "days"),
      };

      localStorage.setItem("orderData", JSON.stringify(orderData));

      if (res.status === 200 && res.data.redirectUrl) {
        // Redirect to payment URL if provided in the response
        window.location.href = res.data.redirectUrl;
      } else {
        message.error("Payment initiation failed. Please try again.");
      }
    } catch (error: any) {
      console.error("Error:", error);
      message.error("Something went wrong!");
    }
  };

  const handlePayment = async () => {
    const token = sessionStorage.getItem("token"); 
             if(!token){
               message.error("Login required!") 
               return
             }

    const calculateCartTotal = () => {
      const baseTotal = data?.cart.reduce((total, item, index) => {
        const itemPrice = item.variant.dealPrice;
        const itemTotal = itemPrice * quantities[index];
        return total + itemTotal;
      }, 0);

      const deliveryFee = deliveryType === "Standard" ? 0 : 100;

      const total = baseTotal && baseTotal + deliveryFee;
      return total ? total.toFixed(2) : "0";
    };

    const totalAmount = parseFloat(calculateCartTotal());
    const discountAmount = (totalAmount * discountPercent) / 100;
    const finalAmount =
      totalAmount - discountAmount >= 1000
        ? (totalAmount - discountAmount).toFixed(2)
        : (totalAmount - discountAmount + 100).toFixed(2);

    const dta = localStorage.getItem("address");
    let updatedShippingAddress;

    if (dta === "SameAddress") {
      updatedShippingAddress = { shippingAddress: isAddress };
    } else {
      updatedShippingAddress = { gstAddress: isAddress };
    }

    const orderData = {
      user: data?._id,
      products: data?.cart.map((item, index) => ({
        productId: item.product,
        productPrice: item.variant.dealPrice
          ? item.variant.dealPrice
          : item.variant.price,
        quantity: quantities[index],
        ram: item.variant.ramSize,
        storage: item.variant.storage,
        colorName: item.variant.colorName,
        productName: item.productName,
        variantId: item.variantId,
        categories: item.categories,
      })),
      ...(dta === "SameAddress"
        ? { shippingAddress: isAddress }
        : { gstAddress: isAddress }),
      ...(dta === "SameAddress" ? { isGst: false } : { isGst: true }),
      totalAmount,
      finalAmount,
      orderDate: new Date(),
      paymentMethod: "cash",
      totalDiscountedAmount: discountAmount,
      paymentStatus: "pending",
      paymentAmount: finalAmount,
      status: "ordered",
      exchange: data?.ExchangeType === "without exchange" ? false : true,
      deliveryType: deliveryType,

      deliveryDate:
        deliveryType === "Standard"
          ? moment().add(pincodeRes[0]?.standardDeliveryDate, "days")
          : moment().add(pincodeRes[0]?.expressDeliveryDate, "days"),
    };

    try {
      const res = await axios.post(`${API_URL}/api/orders`, orderData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      success("Order Placed Successfully");
      await handleclearCart();
      setIsPayment(false);
      setOpen(true);
      eventManager.emit("cartUpdated");
    } catch (error: any) {
      console.log(error.message);
      errormessage(
        error.response?.data?.message || "Failed to fetch products."
      );
    }
  };

  useEffect(() => {
    if (data?.shippingAddress) {
      setIsAddress(data.shippingAddress);
    }
  }, [data]);

  useEffect(() => {
    getUser();
  }, [eventManager.emit("cartUpdated")]);

  const handleSaveClick = () => {
    setIsAddressSaved(true);
  };

  const handleToggleShowAddress = () => {
    setShowAddressForm((prev) => !prev);
  };

  return (
    <>
      {contextHolder}
      <section className="pb-4" style={{ paddingTop: "6rem" }}>
        <Container>
          <div>
            <p className="title-para">Home - Cart</p>
            <h2 className="title-navhead">Cart</h2>
          </div>
          {data?.cart?.length && data.cart.length > 0 ? (
            <div className="row py-3">
              <div className="col-lg-7 col-md-12 col-sm-12 col-12 py-2">
                <div className="cart-box">
                  {!showAddressForm ? (
                    <>
                      {data?.cart?.map((val: any, i: any) => {
                        const handlepincode = ogPincode.filter(
                          (item: any) => item.pincode === val.pincode
                        )[0];

                        return (
                          <div className="row py-2" key={i}>
                            <div className="col-lg-2">
                              <div>
                                <img
                                  className="img-fluid cart-imgs"
                                  src={`${val.variant.images[0]}`}
                                  alt="product"
                                  loading="lazy"
                                />
                              </div>
                            </div>
                            <div className="col-lg-10">
                              <div>
                                <div className="d-flex justify-content-between align-items-center cart-in">
                                  <div>
                                    <h3 className="fw-bold">
                                      {val.productName}{" "}
                                      {`(${
                                        val.variant?.ramSize
                                          ? `${val.variant.ramSize},`
                                          : ""
                                      }${
                                        val.variant?.storage
                                          ? ` ${val.variant.storage},`
                                          : ""
                                      }${
                                        val.variant?.colorName
                                          ? ` ${val.variant.colorName}`
                                          : ""
                                      })`}
                                    </h3>
                                  </div>
                                  <div>
                                    <h3 className="fw-bold">
                                      ₹{" "}
                                      {(
                                        val.variant.dealPrice * quantities[i]
                                      ).toFixed(2)}
                                    </h3>

                                    <div className="quantity">
                                      <a
                                        className="quantity__minus"
                                        onClick={() => handleDecrement(i)}
                                        style={{ cursor: "pointer" }}
                                      >
                                        <span>-</span>
                                      </a>
                                      <input
                                        name="quantity"
                                        type="text"
                                        className="quantity__input"
                                        value={quantities[i]}
                                      />
                                      <a
                                        className="quantity__plus"
                                        onClick={() => handleIncrement(i)}
                                        style={{ cursor: "pointer" }}
                                      >
                                        <span>+</span>
                                      </a>
                                    </div>
                                  </div>
                                </div>
                                <div className="d-flex justify-content-between align-items-center cart-dis py-3">
                                  <div>
                                    <p className="mb-0">
                                      Discount{" "}
                                      <span style={{ color: "#2FB300" }}>
                                        (
                                        {(
                                          ((val.variant.price -
                                            val.variant.dealPrice) /
                                            val.variant.price) *
                                          100
                                        ).toFixed()}
                                        %)
                                      </span>
                                    </p>
                                  </div>
                                  <div
                                    style={{ textAlign: "end", width: "100%" }}
                                  >
                                    <p className="mb-0 off-d">
                                      ₹{" "}
                                      <s>
                                        {(
                                          val.variant.price * quantities[i]
                                        ).toFixed(2)}
                                      </s>
                                    </p>
                                    <p className="saveprice">
                                      ( Save{" "}
                                      {val.variant.price -
                                        val.variant.dealPrice}
                                      )
                                    </p>
                                  </div>
                                  <div className="d-flex justify-content-end align-items-center cart-dis ms-2">
                                    <span
                                      style={{ cursor: "pointer" }}
                                      onClick={() => handleremoveCart(val)}
                                    >
                                      <MdDeleteOutline
                                        style={{
                                          color: "red",
                                          fontSize: "22px",
                                        }}
                                      />
                                    </span>
                                    {/* <div>
                                {val.DeliveryType === "standard delivery" ? (
                                  <p className="mb-0">
                                    Standard delivery by{" "}
                                    {moment(
                                      handlepincode?.standardDeliveryDate
                                    ).format("ddd,DD-MM-YYYY") ||
                                      "Not available"}
                                  </p>
                                ) : (
                                  <p className="mb-0">
                                    Express delivery by{" "}
                                    {moment(
                                      handlepincode?.expressDeliveryDate
                                    ).format("ddd,DD-MM-YYYY") ||
                                      "Not available"}
                                  </p>
                                )}
                              </div> */}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}

                      <hr />

                      <div>
                        <label className="pb-2" style={{ fontWeight: 600 }}>
                          Delivery type:
                        </label>
                        <div className="d-flex">
                          <div>
                            <Radio.Group
                              onChange={onChangeType}
                              value={deliveryType}
                            >
                              <Space direction="vertical">
                                <Radio value={"Standard"}>
                                  Standard Delivery
                                </Radio>
                                <Radio value={"Express"}>
                                  Express Delivery(₹ 100)
                                </Radio>
                              </Space>
                            </Radio.Group>
                          </div>
                          {/* 
                          <div>
                            <Radio.Group>
                              <label
                                className="pb-2"
                                style={{ fontWeight: 600 }}
                              >
                                Address type:
                              </label>
                              <Space direction="vertical">
                                <Radio value={"SameAddress"}>
                                  Same as Shipping Address
                                </Radio>
                                <Radio value={"GSTinvoice"}>GST Invoice</Radio>
                              </Space>
                            </Radio.Group>
                          </div> */}
                        </div>
                      </div>
                    </>
                  ) : (
                    <div className="address-form-container">
                      <ShippingAddress
                        initialData={addressData}
                        onSave={handlepostAddress}
                        enableButton={enableCartButton}
                        isAddress={isAddress}
                        setIsAddress={setIsAddress}
                        isSaved={isAddressSaved}
                      />
                    </div>
                  )}
                </div>
                <div className="d-flex justify-content-between align-items-center pt-4 pb-2">
                  <Button
                    className={`seemore ${
                      showAddressForm ? "seemorenone" : ""
                    }`}
                  >
                    <Link to="/">Shop more</Link>
                  </Button>
                  <div className="btn-cover-ship">
                    <div>
                      <Button
                        className={`continue ${
                          showAddressForm ? "" : "rightmost"
                        }`}
                        onClick={handleToggleShowAddress}
                      >
                        {showAddressForm ? "Back" : "continue"}
                      </Button>
                    </div>
                    <div>
                      {/* <button onClick={handleSaveClick} className={`seemorenone ${
                      showAddressForm ? "save-add" : ""
                    }`}>
                    Save  Address
                  </button>
                  <Button className="save" onClick={handlepostAddress}>
                    Save
                  </Button> */}
                    </div>
                  </div>
                </div>
              </div>
              {isContinue && (
                <div className="col-lg-5 col-md-12 col-sm-12 col-12 py-2">
                  <div className="coupon-box">
                    <div className="">
                      <label className="pb-2">Apply coupon code</label>
                      <br />
                      <input
                        className="p-1"
                        onChange={(e) =>
                          setCoupon({ ...coupon, couponcode: e.target.value })
                        }
                      />
                      <Button
                        className="hh-btn"
                        onClick={checkCoupon}
                        disabled={isCouponApplied}
                      >
                        Apply
                      </Button>
                    </div>
                    {coupon.message !== "" && (
                      <p className="mb-0" style={{ color: "#91d94d" }}>
                        {coupon.message}
                      </p>
                    )}
                  </div>
                  <div className=" box-summary mt-3 ">
                    <h5>Order Summary</h5>
                    <table>
                      <tr>
                        <td>Order Total ( Include all tax )</td>
                        <td>₹ {calculateOrderTotal()}</td>
                      </tr>
                      <tr>
                        <td>Coupon Code</td>
                        <td style={{ color: "#006817" }}>
                          {couponCode ? couponCode : "-"}
                        </td>
                      </tr>
                      <tr>
                        <td>Shipping charges</td>
                        <td>₹ {shippingCharges}</td>
                      </tr>

                      <tr>
                        <td className="fw-bold">Total </td>
                        {discount > 0 ? (
                          <td className="fw-bold">
                            ₹{" "}
                            {shippingCharges === "Free"
                              ? totalprice.toFixed(2)
                              : (totalprice + 100).toFixed(2)}
                          </td>
                        ) : (
                          <td className="fw-bold">
                            ₹ {calculateOrderTotal()}
                            {/* {shippingCharges === "Free"
                              ? calculateOrderTotal()
                              : (totalprice + 100).toFixed(2)} */}
                          </td>
                        )}
                      </tr>
                    </table>
                    {/* <div className="text-center py-3">
                      <Button
                        className="place-btn"
                        disabled={!isButtonEnabled}
                        onClick={handleOpen}
                      >
                        Place your order
                      </Button>
                    </div> */}
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div className="text-center py-5">
              <img
                src="/assets/Shopping_Basket_2.png"
                className="img-fluid"
                style={{ width: "200px" }}
              />
              <p style={{ fontWeight: 600 }}>Your cart is empty</p>
              <Link to="/">
                <Button variant="outlined" className="explorebtn">
                  Continue Shopping
                </Button>
              </Link>
            </div>
          )}
        </Container>
      </section>
      {/* <Suggested /> */}

      {/* Model after place order */}
      <div>
        <Modal
          open={open}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <div className="model-success text-center">
              <img className="img-fluid" src="/assets/Vnext bag.png" />
              <h4>Thank you for your order</h4>
              <p>
                We are thrilled to confirm your order and to view your complete
                order details, track or make any changes, simply click the
                button below.
              </p>
              <Button onClick={handleClose}>View Orders</Button>
            </div>
          </Box>
        </Modal>
      </div>

      {/* Model for Address */}
      {/* <div>
        <Modal
          open={isLoc}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style} className="address-box">
            <div className="">
              <div className="d-flex justify-content-between align-items-center pb-3">
                <h3>My Address</h3>
                <IoIosCloseCircleOutline
                  style={{ cursor: "pointer" }}
                  className="fs-5"
                  onClick={() => setIsloc(false)}
                />
              </div>
              <div className="row address">
                <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                  <div>
                    <label>
                      First Name <span style={{ color: "red" }}>*</span>
                    </label>
                    <br />
                    <input
                      value={isAddress.firstName}
                      onChange={(e) =>
                        setIsAddress({
                          ...isAddress,
                          firstName: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                  <div>
                    <label>
                      Last Name <span style={{ color: "red" }}>*</span>
                    </label>
                    <br />
                    <input
                      value={isAddress.lastName}
                      onChange={(e) =>
                        setIsAddress({ ...isAddress, lastName: e.target.value })
                      }
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                  <div>
                    <label>
                      House no & Floor <span style={{ color: "red" }}>*</span>
                    </label>
                    <br />
                    <input
                      value={isAddress.houseNumberAndFloor}
                      onChange={(e) =>
                        setIsAddress({
                          ...isAddress,
                          houseNumberAndFloor: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                  <div>
                    <label>
                      Building & Block no{" "}
                      <span style={{ color: "red" }}>*</span>
                    </label>
                    <br />
                    <input
                      value={isAddress.buildingAndBlockNumber}
                      onChange={(e) =>
                        setIsAddress({
                          ...isAddress,
                          buildingAndBlockNumber: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                  <div>
                    <label>
                      Locality <span style={{ color: "red" }}>*</span>
                    </label>
                    <br />
                    <input
                      value={isAddress.locality}
                      onChange={(e) =>
                        setIsAddress({ ...isAddress, locality: e.target.value })
                      }
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                  <div>
                    <label>
                      Pin Code <span style={{ color: "red" }}>*</span>
                    </label>
                    <br />
                    <input
                      value={isAddress.pincode}
                      onChange={(e) =>
                        setIsAddress({ ...isAddress, pincode: e.target.value })
                      }
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                  <div>
                    <label>
                      Phone No <span style={{ color: "red" }}>*</span>
                    </label>
                    <br />
                    <input
                      value={isAddress.phoneNumber}
                      onChange={(e) =>
                        setIsAddress({
                          ...isAddress,
                          phoneNumber: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                  <div>
                    <label>
                      Email id <span style={{ color: "red" }}>*</span>
                    </label>
                    <br />
                    <input
                      value={isAddress.email}
                      onChange={(e) =>
                        setIsAddress({ ...isAddress, email: e.target.value })
                      }
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                  <div>
                    <label>
                      Alternate Number <span style={{ color: "red" }}>*</span>
                    </label>
                    <br />
                    <input
                      value={isAddress.alternateNumber}
                      onChange={(e) =>
                        setIsAddress({
                          ...isAddress,
                          alternateNumber: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                  <div>
                    <label>
                      Landmark <span style={{ color: "red" }}>*</span>
                    </label>
                    <br />
                    <input
                      value={isAddress.landmark}
                      onChange={(e) =>
                        setIsAddress({ ...isAddress, landmark: e.target.value })
                      }
                    />
                  </div>
                </div>
                <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                  <div>
                    <label>
                      Address Type <span style={{ color: "red" }}>*</span>
                    </label>
                    <br />
                    <Radio.Group
                      onChange={onChange}
                      value={isAddress.addressType}
                    >
                      <Radio value={"Home"}>Home</Radio>
                      <Radio value={"Work"}>Work</Radio>
                      <Radio value={"Other"}>Other</Radio>
                    </Radio.Group>
                  </div>
                </div>
                <div className="text-center py-3">
                  <Button className="save" onClick={handlepostAddress}>
                    Save
                  </Button>
                </div>
              </div>
            </div>
          </Box>
        </Modal>
      </div> */}

      {/* Payment isPayment*/}
      <Modal
        open={isPayment}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className="d-flex justify-content-between align-items-center pb-3">
            <h3>Payment</h3>
            <IoIosCloseCircleOutline
              style={{ cursor: "pointer" }}
              className="fs-5"
              onClick={() => setIsPayment(false)}
            />
          </div>
          <div className="text-center">
            <div>
              <Button onClick={handlePhonepe} className="btn-pay">
                Online Payment
              </Button>
            </div>
            <div className="mt-3">
              <Button onClick={handlePayment} className="btn-pay">
                Cash On Delivery
              </Button>
            </div>
          </div>
        </Box>
      </Modal>
    </>
  );
};

export default Cart;
